import React, { Component } from "react";
import { connect } from "react-redux";

import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	Label,
	Spinner,
} from "reactstrap";

import { MRDetailsModel_close } from "../store/PurchaseIndent/actions";
import moment from "moment";

class GetMRDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	// componentDidMount() {
	// 	console.log(this.props.MRRowData, "MRRowData");
	// }

	render() {
		return (
			<React.Fragment>
				<Modal
					isOpen={this.props.MRDetailsModel}
					backdrop="static"
					centered
					size="lg">
					<ModalHeader
						toggle={() => this.props.MRDetailsModel_close()}>
						REQUEST DETAILS ({this.props.MRRowData.code})
					</ModalHeader>

					<ModalBody>
						<Row className="p-2">
							<Col md="12" className="p-1 m-0">
								{this.props.loading ? (
									<>
										<div className="text-center">
											<Spinner color="primary" size="">
												Loading...
											</Spinner>
										</div>
									</>
								) : (
									<div className="Order-panel-content">
										<div className="list-column">
											<ul className="list-style-three p-0">
												<li className="clearfix">
													<span className="ttl">
														SR status:
													</span>
													<span className="dtl">
														{(this.props.MRRowData
															.mrstatus === 1 ||
															this.props.MRRowData
																.mrstatus ===
																2) && (
															<Label className="font-size-16  text-primary">
																Pending
															</Label>
														)}
														{this.props.MRRowData
															.mrstatus === 3 && (
															<Label className="font-size-16  text-success">
																HOD Approved
															</Label>
														)}

														{(this.props.MRRowData
															.mrstatus === 5 ||
															this.props.MRRowData
																.mrstatus ===
																7 ||
															this.props.MRRowData
																.mrstatus ===
																8) && (
															<Label className="font-size-16  text-success">
																Admin Approved
															</Label>
														)}
														{this.props.MRRowData
															.mrstatus === 4 && (
															<Label className="font-size-16  text-danger">
																HOD Rejected
															</Label>
														)}
														{this.props.MRRowData
															.mrstatus === 6 && (
															<Label className="font-size-16  text-danger">
																Admin Rejected
															</Label>
														)}
													</span>
												</li>
												<li className="clearfix">
													<span className="ttl">
														HOD(U) Approved by:
													</span>
													<span className="dtl">
														{this.props.MRRowData
															.userDeptApprovedby &&
															this.props.MRRowData
																.userDeptApprovedby[
																this.props
																	.MRRowData
																	.userDeptApprovedby
																	.length - 1
															]?.approvedby
																.fullname}
													</span>
												</li>
												<li className="clearfix">
													<span className="ttl">
														HOD(U) Approved Date:
													</span>
													<span className="dtl">
														{moment(
															this.props.MRRowData
																.userDeptApprovedby &&
																this.props
																	.MRRowData
																	.userDeptApprovedby[
																	this.props
																		.MRRowData
																		.userDeptApprovedby
																		.length -
																		1
																]?.createdon
														).format("DD-MM-YYYY")}
													</span>
												</li>
												<li className="clearfix">
													<span className="ttl">
														Location:
													</span>
													<span className="dtl">
														{
															this.props.MRRowData
																.location?.name
														}
													</span>
												</li>
												<li className="clearfix">
													<span className="ttl">
														Sub Location:
													</span>
													<span className="dtl">
														{
															this.props.MRRowData
																.sublocation
																?.name
														}
													</span>
												</li>
												<li className="clearfix">
													<span className="ttl">
														Order Location:
													</span>
													<span className="dtl">
														{
															this.props.MRRowData
																?.orderlocation
																?.name
														}
													</span>
												</li>
												{/* <li className="clearfix">
                                          <span className="ttl">
                                            Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.MRRowData.department
                                                ?.name
                                            }
                                          </span>
                                        </li> */}
												<li className="clearfix">
													<span className="ttl">
														User Department:
													</span>
													<span className="dtl">
														{
															this.props.MRRowData
																.userdepartment
																?.name
														}
													</span>
												</li>
												<li className="clearfix">
													<span className="ttl">
														User Name:
													</span>
													<span className="dtl">
														{
															this.props.MRRowData
																.createdby
																?.fullname
														}
													</span>
												</li>
												<li className="clearfix">
													<span className="ttl">
														Submited Date:
													</span>
													<span className="dtl">
														{moment(
															this.props.MRRowData
																.createdon
														).format("DD-MM-YYYY")}
													</span>
												</li>
												<li className="clearfix">
													<span className="ttl">
														Required Date:
													</span>
													<span className="dtl">
														{moment(
															this.props.MRRowData
																.date
														).format("DD-MM-YYYY")}
													</span>
												</li>
												<li className="clearfix">
													<span className="ttl">
														Description:
													</span>
													<span className="dtl">
														{
															this.props.MRRowData
																.description
														}
													</span>
												</li>
												{(this.props.MRRowData
													.mrstatus === 4 ||
													this.props.MRRowData
														.mrstatus === 6) && (
													<li className="clearfix">
														<span className="ttl text-danger ">
															Reject Remark :
														</span>
														<span className="dtl">
															{
																this.props
																	.MRRowData
																	.mr_approvals[
																	this.props
																		.MRRowData
																		.mr_approvals
																		.length -
																		1
																].description
															}
														</span>
													</li>
												)}
											</ul>
										</div>
									</div>
								)}
							</Col>
						</Row>
					</ModalBody>
				</Modal>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { MRDetailsModel, MRRowData, loading } = state.PurchaseIndent;

	return {
		MRDetailsModel,
		MRRowData,
		loading,
	};
};

export default connect(mapStatetoProps, {
	MRDetailsModel_close,
})(GetMRDetails);
